import React, { memo } from 'react';
import ContinuousCarousel from './ContinuousCarousel/ContinuousCarousel';
import styles from './Desktop.module.scss';

const Desktop = memo(function Desktop({ articles, readText }) {
  return (
    <div className={styles.wrapper}>
      <ContinuousCarousel articles={articles} readText={readText} />
    </div>
  );
});

export default Desktop;
